import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {AuthCheck} from '../../helpers'
import {AuthorizedApiBase} from '../../api/api-client-config'

const SERVICE_URL = window.ENVVARS.REACT_APP_SERVICE_URL

class EdmSettingsClient extends AuthorizedApiBase {
  constructor(baseUrl) {
    super()
    this.baseUrl = baseUrl
    this.http = window
  }
  getSettings() {
    const url = `${this.baseUrl}/api/v1/edm/settings`
    const options = {method: 'GET', headers: {Accept: 'application/json'}}
    return this.transformOptions(options)
      .then((opts) => this.http.fetch(url, opts))
      .then((response) => {
        if (response.status === 200) return response.json()
        return response.text().then((text) => { throw new Error(text || 'Ayarlar alınamadı') })
      })
  }
  updateSettings(body) {
    const url = `${this.baseUrl}/api/v1/edm/settings`
    const options = {
      method: 'PUT',
      headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
      body: JSON.stringify(body),
    }
    return this.transformOptions(options)
      .then((opts) => this.http.fetch(url, opts))
      .then((response) => {
        if (response.status === 200) return response.json()
        return response.text().then((text) => { throw new Error(text || 'Ayarlar kaydedilemedi') })
      })
  }
}

const client = new EdmSettingsClient(SERVICE_URL)

const initialState = {
  loading: false,
  saveLoading: false,
  error: null,
  settings: null,
}

export const edmGetSettings = createAsyncThunk(
  'edmsettings/getSettings',
  async (_, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await client.getSettings()
      dispatch(setSettings(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error?.message || 'Ayarlar alınırken hata oluştu'))
      throw error
    }
  }
)

export const edmUpdateSettings = createAsyncThunk(
  'edmsettings/updateSettings',
  async (body, {dispatch}) => {
    try {
      dispatch(setSaveLoading(true))
      const response = await client.updateSettings(body)
      dispatch(setSaveLoading(false))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error?.message || 'Ayarlar kaydedilirken hata oluştu'))
      throw error
    }
  }
)

const edmsettingsSlice = createSlice({
  name: 'edmsettings',
  initialState,
  reducers: {
    setLoading: (state, action) => { state.loading = action.payload },
    setSaveLoading: (state, action) => { state.saveLoading = action.payload },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
      state.saveLoading = false
    },
    setSettings: (state, action) => {
      state.settings = action.payload
      state.loading = false
    },
    clearError: (state) => { state.error = null },
  },
})

export const {setLoading, setSaveLoading, setError, setSettings, clearError} = edmsettingsSlice.actions

export const selectEdmSettings = (state) => state.edmsettings.settings
export const selectEdmSettingsLoading = (state) => state.edmsettings.loading
export const selectEdmSettingsSaveLoading = (state) => state.edmsettings.saveLoading
export const selectEdmSettingsError = (state) => state.edmsettings.error

export default edmsettingsSlice.reducer
